import { render, staticRenderFns } from "./ManagePermissionModal.vue?vue&type=template&id=63221ed6&scoped=true"
import script from "./ManagePermissionModal.vue?vue&type=script&lang=js"
export * from "./ManagePermissionModal.vue?vue&type=script&lang=js"
import style0 from "./ManagePermissionModal.vue?vue&type=style&index=0&id=63221ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63221ed6",
  null
  
)

export default component.exports